// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCNEGCW9jZpRsB4OJz0DASPJrkakqrBDt8",
  authDomain: "kare-oss.firebaseapp.com",
  projectId: "kare-oss",
  storageBucket: "kare-oss.appspot.com",
  messagingSenderId: "326804462652",
  appId: "1:326804462652:web:f76de4f09975a3e2183739",
  measurementId: "G-R93W673JK3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const authentication = getAuth(app);